import { Base } from './base.model';
export class UserDetail {
  public oldPassword = new Base();
  public newPassword = new Base();
  public confirmPassword = new Base();
  public lastName = new Base();
  public firstName = new Base();
  public preferredCultureCode = new Base();
  public valid = true;
  public userEditValid = true;

  public customValidate() {
    this.oldPassword.errorMessage = '';
    this.newPassword.errorMessage = '';
    this.confirmPassword.errorMessage = '';

    if (this.newPassword.value !== this.confirmPassword.value) {
      this.valid = false;
      this.confirmPassword.errorMessage = 'error.passwordNotMatch';
    }
  }

  public resetCustomErrors(): void {
    this.oldPassword.errorMessage = '';
    this.newPassword.errorMessage = '';
    this.confirmPassword.errorMessage = '';
  }
}
